/*
  Share-link source markers carried as ?s= on tracked short links (go.shopmy.us/p-{id},
  /c-{id}) and recorded on referrer rows. Senders build markers with buildShareLinkSource
  and the node-side decoder validates against these same tables, so a drifted literal in
  one package can't silently drop a click's attribution.
*/

const SHARE_LINK_SOURCE_PREFIX = 'sl1';

const SHARE_LINK_TEMPLATE_KEY_BY_SOURCE_CODE = {
  stk: 'sticker',
  sph: 'split_horizontal',
  spv: 'split_vertical',
  shc: 'showcase',
  mst: 'mini_sticker',
  pl1: 'product_link',
  pl2: 'product_photo',
  bp1: 'brand_partner',
  bup: 'brand_upload',
  bgr: 'brand_grey',
  gen: 'generic',
  sdm: 'smart_dm',
  ccr: 'collection_carousel',
  cmo: 'collection_mosaic',
  csp: 'collection_split',
  ccv: 'collection_cover'
};

const SHARE_LINK_DESTINATION_KEY_BY_SOURCE_CODE = {
  cpl: 'copy_link',
  igs: 'instagram_stories',
  igdm: 'instagram_dm',
  sav: 'save_image',
  shr: 'system_share_sheet',
  cpi: 'copy_image'
};

const buildShareLinkSource = (templateSourceCode, destinationSourceCode) => {
  if (!SHARE_LINK_TEMPLATE_KEY_BY_SOURCE_CODE[templateSourceCode] || !SHARE_LINK_DESTINATION_KEY_BY_SOURCE_CODE[destinationSourceCode]) {
    throw new Error(`Unknown share-link source codes: ${templateSourceCode}_${destinationSourceCode}`);
  }
  return `${SHARE_LINK_SOURCE_PREFIX}_${templateSourceCode}_${destinationSourceCode}`;
};

module.exports = {
  SHARE_LINK_SOURCE_PREFIX,
  SHARE_LINK_TEMPLATE_KEY_BY_SOURCE_CODE,
  SHARE_LINK_DESTINATION_KEY_BY_SOURCE_CODE,
  buildShareLinkSource
};
